import cls from "./sidebar.module.scss";
import Link from "next/link";
import { useTranslation } from "react-i18next";
import Store2FillIcon from "remixicon-react/Store2FillIcon";
import RestaurantFillIcon from "remixicon-react/RestaurantFillIcon";
import Heart3LineIcon from "remixicon-react/Heart3LineIcon";
import CustomerServiceLineIcon from "remixicon-react/CustomerServiceLineIcon";
import ArrowRightSLineIcon from "remixicon-react/ArrowRightSLineIcon";
import LogoutCircleRLineIcon from "remixicon-react/LogoutCircleRLineIcon";
import { Category } from "interfaces";
import scrollToView from "utils/scrollToView";
import { useAuth } from "contexts/auth/auth.context";
import { useRouter } from "next/router";
import LoginCircleLineIcon from "remixicon-react/LoginCircleLineIcon";
import { useMemo } from "react";
import { profileDropdownLinks } from "components/profileDropdown/profileDropdownLinks";

type Props = {
  data?: Category[];
  onClose?: () => void;
  withLinks?: boolean;
};

export default function Sidebar({ data, withLinks = false, onClose }: Props) {
  const { t } = useTranslation();
  const { query, pathname } = useRouter();
  const { logout, isAuthenticated, openAuthModal } = useAuth();

  const links = useMemo(() => {
    if (isAuthenticated) {
      return profileDropdownLinks.filter((item) => item.href !== "/shop");
    }
    return profileDropdownLinks.filter(
      (item) => !item.requiredAuth && item.href !== "/shop",
    );
  }, [isAuthenticated]);

  const handleLogout = () => {
    logout();
  };
  const handleClose = () => {
    if (onClose) {
      onClose();
    }
  };

  const renderAuthButton = () => {
    if (!isAuthenticated) {
      return (
        <button
          type="button"
          className={cls.link}
          onClick={() => openAuthModal()}
        >
          <div className={cls.body}>
            <LoginCircleLineIcon size={24} />
            <span>{t("login")}</span>
          </div>
          <ArrowRightSLineIcon size={20} />
        </button>
      );
    }

    return (
      <button type="button" className={cls.link} onClick={handleLogout}>
        <div className={cls.body}>
          <LogoutCircleRLineIcon size={24} />
          <span>{t("log.out")}</span>
        </div>
        <ArrowRightSLineIcon size={20} />
      </button>
    );
  };

  return (
    <aside className={cls.container}>
      <div className={cls.links}>
        <Link
          href="/shop"
          className={`${cls.link} ${pathname === "/shop" && cls.active}`}
        >
          <div className={cls.body}>
            <Store2FillIcon size={24} />
            <span>{t("shops")}</span>
          </div>
        </Link>
        {/* <Link
          href={{ pathname: "/recipes", query: { shop_id: query?.id } }}
          className={`${cls.link} ${pathname.includes("/recipes") && cls.active}`}
        >
          <div className={cls.body}>
            <RestaurantFillIcon size={24} />
            <span>{t("recipes")}</span>
          </div>
        </Link> */}
        {!withLinks && (
          <Link
            href={{
              pathname: "/liked/products",
              query: { shop_id: query?.id },
            }}
            className={`${cls.link} ${pathname.includes("/liked/products") && cls.active}`}
          >
            <div className={cls.body}>
              <Heart3LineIcon size={24} />
              <span>{t("liked.products")}</span>
            </div>
          </Link>
        )}
        {withLinks &&
          links.map((item) => (
            <Link
              href={item.href}
              className={`${cls.link} ${pathname === item.href && cls.active}`}
              key={item.href}
              onClick={handleClose}
            >
              <div className={cls.body}>
                {item.icon}
                <span>{t(item.label)}</span>
              </div>
            </Link>
          ))}
      </div>
      {!!data?.length && (
        <div className={cls.categoryContainer}>
          {data?.map((category) => (
            <button
              onClick={() => scrollToView(category?.uuid, -70)}
              type="button"
              key={category?.id}
              className={cls.category}
            >
              {category?.translation?.title}
            </button>
          ))}
        </div>
      )}
      <div className={cls.links}>
        <Link
          href="/help"
          className={`${cls.link} ${pathname.includes("/help") && cls.active}`}
        >
          <div className={cls.body}>
            <CustomerServiceLineIcon size={24} />
            <span>{t("help.center")}</span>
          </div>
          <ArrowRightSLineIcon size={20} />
        </Link>
        {renderAuthButton()}
      </div>
    </aside>
  );
}
